module.exports = __webpack_public_path__ + "img/huiben.65dfc31f.webp";